import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { Advice } from './Advice';
import { useNavigate } from 'react-router-dom';

const AdaptedAdvice = {

  Sleep: {
    icon: 'bed-outline',
    label: "Sleep",
    description: "Get some rest. The first thing to do is create a bedtime routine and stick to it. If you decide to hit the pillow at 10 p.m., go to bed every night at that hour. Strive for 7 to 9 hours of sleep every night.",
  },
  Water: {
    icon: "water",
    label: "Water",
    description: "A general guideline is to drink at least 8 glasses or 64 ounces of water per day for an average adult. This can help to ensure that the body stays hydrated and functions properly. Some experts suggest that a better way to determine the appropriate daily water intake is to consume half of your body weight in ounces of water. For example, if you weigh 150 pounds, you would need to drink 75 ounces of water per day.",
  },
  Stress: {
    icon: "flash-outline",
    label: "Stress",
    description: "To prevent these negative effects, managing stress through techniques like meditation, exercise, and self-care is crucial for maintaining healthy skin and appearance.",
  },
  UV: {
    icon: "sunny-outline",
    label: "UV",
    description: "To maintain healthy skin and minimize the negative effects of sunlight, it is important to protect the skin by wearing sunscreen, protective clothing, and seeking shade during peak sunlight hours.",
  },
  AirQuality: {
    icon: "cloudy-outline",
    label: "Air Quality",
    description: "To prevent these negative effects, managing stress through techniques like meditation, exercise, and self-care is crucial for maintaining healthy skin and appearance.",
  },
  LowHumidity: {
    icon: "water",
    label: "Humidity",
    description: "To mitigate the negative effects of low humidity, it is important to moisturize the skin regularly, avoid hot showers, use a humidifier, and protect the skin from harsh weather conditions.",
  },
  HighHumidity: {
    icon: "water",
    label: "Humidity",
    description: "High levels of humidity promotes natural moisture retention but can result in excess oil production.",
  },
};


export const AdvicePage = ({ humidity }) => {

  const navigate = useNavigate();
  const handleSubmit = async () => {
    console.log('added to email')
  };

  return (
    <View style={styles.background}>
      <View style={styles.container}>
        <View style={styles.header}>
          <Text style={styles.title}>Adapted Advice</Text>
          <Text style={styles.description}>Skin health advice from our experts.</Text>
        </View>

        <View style={styles.content}>
          {humidity > 63 ? (
            <Advice {...AdaptedAdvice.HighHumidity} />
          ) : (
            <Advice {...AdaptedAdvice.LowHumidity} />
          )}
          <Advice {...AdaptedAdvice.Sleep} />
          <Advice {...AdaptedAdvice.Stress} />
          <Advice {...AdaptedAdvice.AirQuality} />
          <Advice {...AdaptedAdvice.Water} />
          <Advice {...AdaptedAdvice.UV} />
        </View>

        <View style={styles.actionContainer}>
          <TouchableOpacity
            style={[
              styles.actionButton]}
            onPress={() => handleSubmit()}
          >
            <Text style={styles.actionText}>Join the product waitlist</Text>
          </TouchableOpacity>
        </View>

      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  background: {
    backgroundColor: '#C7BEB9',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    flex: 1,
    padding: 20,
  },
  header: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontFamily: 'DM Serif Display',
    fontSize: 30,
    fontWeight: 'bold',
    color: '#3B1C15',
    marginTop: 10,
    marginBottom: 10,
  },
  description: {
    color: '#3B1C15',
    fontSize: 25,
    textAlign: 'center',
    fontFamily: 'DM Sans',
    padding: 10,
    fontWeight: 400,
    overflow: 'visible'

  },
  content: {
    flex: 1,
    //flexDirection: 'row',
    padding: 30,
    marginTop: 50
  },
  leftColumn: {
    flex: 2,
    marginRight: 20,
    width: '50%'
  },
  rightColumn: {
    flex: 2,
    marginLeft: 0,
  },
  rightColumnSpacing: {
    height: 20,
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#9EA698',
    width: 300,
    height: 82,
    padding: 10
  },
  actionText: {
    fontFamily: 'DM Serif Display',
    fontSize: 30,
    color: '#FFFFFF',
    textAlign: 'center',
    fontWeight: '400',
  },
  actionContainer: {
    //flex: 1,
    marginTop: -90,
    justifyContent: 'center',
    alignItems: 'center',
    width: 300,
    left: '50%',
    transform: 'translateX(-50%)',
  }
});


